import { productItem } from '../../common';
/**
 * 线路看板
 * @startDate
 * @endDate
 * @scanSite
 * @type
 * @nextSite
*/
export const VolumesQuery = (params) => {
  return [
    {
      // 出发量 ？ 到达量
      dataSource: 'actual_load_unload_result',
      dimensions: ['nextSite'],
      // simpleGranularity: params.type || 'day',
      // simpleGranularity: 'day',
      startDate: params.startDate,
      endDate: params.endDate,
      andFilters: [
        {key: 'nextSite', value: params.nextSite},
        {key: 'scanType', value: '分拨装车'},
        {key: 'isDestinationCenter', value: '否'},
        {key: 'scanSite', value: params.scanSite},
      ],
      durationGranularity: {
        duration: '86400000',
        origin: params.startDate
      }
    },
    // 产品类型
    ProductQuery(params.scanSite, 'nextSite', params.nextSite)
  ]
}

const ProductQuery = (scanSite, type, name) => {
  const unload = [];
  productItem().forEach(item => {
    unload.push({
      dataSource: 'actual_load_unload_result',
      dimensions: [type],
      andFilters: [
        {key: 'productType', value: item},
        {key: type, value: name},
        {key: 'scanType', value: '分拨装车'},
        {key: 'isDestinationCenter', value: '否'},
        {key: 'scanSite', value: scanSite},
      ]
    })
  })
  return unload;
}